import { combineReducers } from "redux";

import generalReducer from "./general/reducer";
import hubReducer from "./hub/reducer";
import identifyReducer from "./identify/reducer";
import loginReducer from "./login/reducer";
import orderReducer from "./order/reducer";
import suppliersReducer from "./supplier/reducer";

export default combineReducers({
  login: loginReducer,
  general: generalReducer,
  hub: hubReducer,
  suppliers: suppliersReducer,
  order: orderReducer,
  identify: identifyReducer,
});
